// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3S0cO","icon":"styles_icon__MnvOQ"};